import { TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { Formatters, Messages } from '../../../../codegen/Localize';
import { classes, cssClass } from '../../../../style';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { sectionHeaderClass, sectionTitleClass } from '../../../styles/DefinitionSubspaceSharedStyles';
import { ValueConcept } from '../../../types/ValueConcept';
import { useRadioEditContext } from '../../../utils/RadioEditProvider';
import { DefinitionSubspaceValuesControls } from './DefinitionSubspaceValuesToolbar';
import { ValuesSectionEditButtons } from './ValuesSectionEditButtons';
import { ValuesSectionValuesGrid } from './ValuesSectionValuesGrid';

const MAX_VALUE_COUNT = 10000;

export interface DefinitionSubspaceValuesSectionProps {
  readonly valuesList: ReadonlyArray<ValueConcept>;
}

const cssPrefix = 'DefinitionSubspaceValuesSection';
const sectionClass = cssClass(cssPrefix, 'section', {flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden'});
const dataGridWrapperClass = cssClass(cssPrefix, 'topRow', {position: 'relative', flex: 1, width: '100%', fontSize:'14px', display: 'flex', flexDirection: 'column', overflowY: 'hidden'});
const titleRealignClass = cssClass(cssPrefix, 'titleRealign', {display: 'inline-block', marginRight: TabStyles.Spacing.LargeSpace});
const maxRowsMessageClass = cssClass(cssPrefix, 'maxRows', { display: 'inline-block', marginLeft: TabStyles.Spacing.LargeSpace, fontSize:'12px'});

export const  DefinitionSubspaceValuesSection = (props: DefinitionSubspaceValuesSectionProps) => {
  const [filterText, setFilterText] = React.useState('');
  const {isReadonly, setIsEditing, isEditing} = useRadioEditContext();

  const valueCount = props.valuesList.length;
  const COUNT = Formatters.formatCount(valueCount);
  const MAXCOUNT = Formatters.formatCount(MAX_VALUE_COUNT);

  return <section className={sectionClass}>
    <header className={sectionHeaderClass}>
      <div>
        <h3 className={`${sectionTitleClass} ${titleRealignClass}`}>
          {Messages.dataRoleDefinitionSubspace_Values_Title({COUNT})}
        </h3>
        <ValuesSectionEditButtons
          {...{isReadonly, setIsEditing, isEditing}}/>
        {FeatureFlags.dataRolesEditValueSynonymsEnabled || valueCount <= MAX_VALUE_COUNT ? null :
          <span className={maxRowsMessageClass}>
            {Messages.dataRoleDefinitionSubspace_Values_MaxRowsMessage({MAXCOUNT})}
          </span>}
      </div>
      <span style={{marginRight: TabStyles.Spacing.MediumSpace}}>
        <DefinitionSubspaceValuesControls
        searchText={filterText}
        onChangeSearch={setFilterText}/>
      </span>
    </header>
    <div className={classes(dataGridWrapperClass, 'tb-datarole-values-list')}>
      <ValuesSectionValuesGrid
        valuesList={props.valuesList}
        valueCount={valueCount}
        isEditing={isEditing}
        filterText={filterText}
        resetFilterText={() => setFilterText('')}/>
    </div>
  </section>;
};
